import React, { useCallback, useMemo, useState } from 'react';
import { Feedback } from '../../components/Feedback/Feedback';
import { Button, Column, Row } from '@husslehq/ui-library';

import { Review } from '../../types/Gym';

type Props = {
  reviews: Review[];
  loadingStep?: number;
  initialView?: number;
};

export const FeedbackBlock: React.FC<Props> = ({ reviews, loadingStep = 10, initialView = 2 }) => {
  const [visibleAmount, setVisibleAmount] = useState(initialView);

  const handleSeeMoreReviewsClick = useCallback(() => {
    setVisibleAmount(visibleAmount + loadingStep);
  }, [visibleAmount]);

  const reviewsList = useMemo(() => {
    return reviews
      .slice(0, visibleAmount)
      .map((item, index) => (
        <Feedback
          key={`feedback_${index}`}
          author={item.author}
          comment={item.comment}
          createdAt={item.created_at}
          score={item.score}
        />
      ));
  }, [reviews, visibleAmount, initialView]);

  return (
    <Row>
      <Column xs="12">{reviewsList}</Column>
      {visibleAmount < reviews.length && (
        <Column xs="12">
          <Button size="medium" level="outline" onClick={handleSeeMoreReviewsClick}>
            See more reviews
          </Button>
        </Column>
      )}
    </Row>
  );
};
